import authentication from 'system/libraries/authentication';
import { useEffect } from "react";
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from 'authConfig';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import AuthErrorPage from 'components/pages/system/AuthErrorPage';
import LoadingPage from 'components/pages/system/LoadingPage';
import {
  withAITracking
} from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./AppInsights";
import MainLayout from "components/layouts/MainLayout";
import EnterpriseAppsPage from "components/pages/EnterpriseAppsPage";
import { BrowserRouter, Route, Routes } from "react-router-dom";

declare var pendo: any;
var iconsInitialized = false;

function AuthenticatedApp() {
  if (authentication.logoutInitialized || authentication.isNotInitialized) {
    return <LoadingPage />;
  }

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
      errorComponent={AuthErrorPage}
      loadingComponent={LoadingPage}
    >
      <MainLayout />
    </MsalAuthenticationTemplate>
  );
}

function App() {
  useEffect(() => {
    if (iconsInitialized) {
      return;
    }
    iconsInitialized = true;
    initializeIcons();
  });

  authentication.context = useMsal();

  useEffect(() => {
    if (authentication.isNotInitialized) {
      return;
    }
    if (!authentication.account) {
      return;
    }

    pendo.initialize({
      visitor: {
        id: authentication.context?.accounts[0]?.localAccountId ?? ''
      },

    });
  });

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/enterprise-apps/*" element={<EnterpriseAppsPage />} />
        <Route path="/*" element={<AuthenticatedApp />} />
      </Routes>
    </BrowserRouter>
  );
}

let app: any;
if (process.env.REACT_APP_APP_INSIGHTS_KEY) {
  app = withAITracking(reactPlugin, App);
} else {
  app = App;
}

export default app;
